<template>
  <div>
    <slot name="content" v-bind="this"></slot>
  </div>
</template>

<script>
export default {
  props: {
    qty: 1,
    productQuantity: null,
  },
  data () {
    return {
      isDisabled: false,
      noProducts: false,
      noProdupropagatects: false,
    }
  },
  methods: {
    plus(ev) {
      ev.preventDefault();

      if (this.productQuantity > this.qty) {
        this.$emit("pluschild");
        this.noProdupropagatects = false;
      } else {
        this.noProducts = true;
        this.noProdupropagatects = true;
      }

    },
    minus(ev) {
      ev.preventDefault();

      if (this.qty > 1) {
        this.$emit("minuschild");
        this.noProducts = false;
      } else {
        this.isDisabled = true;
      }
    }
  },
  mounted() {
  }
}
</script>
